// hooks/usePermissionsFicheEmploye.js
// ============================================================================
// CRÉER ET MODIFIER UNE FICHE D'EMPLOYÉ : PERMISSIONS
// ============================================================================
//
// Le serveur tranche (backend2/routes/employes.routes.js, 14 octobre 2026) ;
// les permissions lues ici évitent seulement de proposer ce qui serait refusé.
//
//   RESSOURCE_HUMAINES.EMPLOYES.CREATE   créer une fiche     POST /api/employes
//   RESSOURCE_HUMAINES.DETAILS.EDIT      modifier une fiche  PUT  /api/employes/:id
//
// Ce sont des actions : le serveur les résout par le RÔLE. `detailedPermissions`
// vient de lui, ALL_MODULES déjà développé et dérogations appliquées — on n'y
// ajoute aucun raccourci (voir PERMISSIONS.md, § 3 bis).
// ============================================================================
import { usePermissions } from './usePermissions';

export const CLES_FICHE_EMPLOYE = {
  creer: 'RESSOURCE_HUMAINES.EMPLOYES.CREATE',
  modifier: 'RESSOURCE_HUMAINES.DETAILS.EDIT'
};

export const usePermissionsFicheEmploye = () => {
  const { detailedPermissions, loading } = usePermissions();
  const cles = new Set((detailedPermissions || []).map((p) => p.permission_key || p.key));
  return {
    peutCreer: cles.has(CLES_FICHE_EMPLOYE.creer),
    peutModifier: cles.has(CLES_FICHE_EMPLOYE.modifier),
    chargement: Boolean(loading)
  };
};
